import axios from "axios";
import { useEffect, useState, useRef } from "react";
import beaconMasterResultType from "../model/BeaconMasterResultType";
import Result from "../components/BeaconMasterResult";
import Header from "../components/Header";
import PageSelect from "../components/PageSelect";
import ExcelJS from 'exceljs';
import "./BeaconMaster.css";

const BeaconMaster = () => {

    const [apiKey, setApikey] = useState<string>("");
    const [id, setId] = useState<string>("");
    const [per_page, setPer_Page] = useState<string>("");
    const [name, setName] = useState<string>("");
    const [local_name, setLocal_name] = useState<string>("");
    const [uuid, setUuid] = useState<string>("");
    const [major, setMajor] = useState<string>("");
    const [minor, setMinor] = useState<string>("");
    const [action_id, setAction_id] = useState<string>("");
    const [tx_power, setTx_power] = useState<string>("");
    const [battery_gt, setBattery_gt] = useState<string>("");
    const [battery_lt, setBattery_lt] = useState<string>("");
    const [module_id, setModule_id] = useState<string>("");
    const [manufacturer, setManufacturer] = useState<string>("");
    const [model, setModel] = useState<string>("");
    const [note, setNote] = useState<string>("");
    const [x, setX] = useState<string>("");
    const [y, setY] = useState<string>("");
    const [h, setH] = useState<string>("");
    const [latitude, setLatitude] = useState<string>("");
    const [longitude, setLongitude] = useState<string>("");
    const [abs_height, setAbs_height] = useState<string>("");
    const [enabled, setEnabled] = useState<string>("");
    const [created_gt, setCreated_gt] = useState<string>("");
    const [created_lt, setCreated_lt] = useState<string>("");
    const [updated_gt, setUpdated_gt] = useState<string>("");
    const [updated_lt, setUpdated_lt] = useState<string>("");
    const [sort, setSort] = useState<string>("");
    const [pageNo, setPageNo] = useState<number>(0);
    const [lastPageNo, setLastPageNo] = useState<number>(0);
    const [total, setTotal] = useState<number>(-1);
    const [result, setResult] = useState<beaconMasterResultType[]>([]);
    const results: beaconMasterResultType[] = [];
    const [csvResult, setCSVResult] = useState<beaconMasterResultType[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);   // CSV全件取得
    const [isFetching, setIsFetching] = useState<boolean>(false); // 検索・ページング
    const [isNoCheck, setNoCheck] = useState<boolean>(false);
    var apiUrl:string = "";

    // ---- UI-only state ----
    const [filterOpen, setFilterOpen] = useState<boolean>(true);
    const [csvOpen, setCsvOpen] = useState<boolean>(false);
    const csvRef = useRef<HTMLDivElement>(null);

    const checkLocoEnv = () => {
      if (localStorage.getItem("locoEnv") === "prod") {
        apiUrl = "https://api.bc-loco.jp/api/beacons"
      } else {
        apiUrl = "http://stg.api.bc-loco.jp/api/beacons"
      }
    }

    const getBeacon = async(e: any, pageNo: number) => {
        e.preventDefault();
        saveParams();
        saveApikey();
        checkLocoEnv();
        setIsFetching(true);
        try {
        await axios.get(apiUrl,
        {
          headers: {
              "Authorization": apiKey,
              "Content-Type": "application/json"
          },
          params: {
              ...(id ? {id: id} : {}),
              ...(pageNo ? {page: pageNo} : {}),
              ...(per_page ? {per_page: per_page} : {}),
              ...(name ? {name: name} : {}),
              ...(local_name ? {local_name: local_name} : {}),
              ...(uuid ? {uuid: uuid} : {}),
              ...(major ? {major: major} : {}),
              ...(minor ? {minor: minor} : {}),
              ...(action_id ? {action_id: action_id} : {}),
              ...(tx_power ? {tx_power: tx_power} : {}),
              ...(battery_gt ? {battery_gt: battery_gt} : {}),
              ...(battery_lt ? {battery_lt: battery_lt} : {}),
              ...(module_id ? {module_id: module_id} : {}),
              ...(manufacturer ? {manufacturer: manufacturer} : {}),
              ...(model ? {model: model} : {}),
              ...(note ? {note: note} : {}),
              ...(x ? {x: x} : {}),
              ...(y ? {y: y} : {}),
              ...(h ? {h: h} : {}),
              ...(latitude ? {latitude: latitude} : {}),
              ...(longitude ? {longitude: longitude} : {}),
              ...(abs_height ? {abs_height: abs_height} : {}),
              ...(enabled ? {enabled: enabled} : {}),
              ...(created_gt ? {created_gt: created_gt.replace("T", " ")} : {}),
              ...(created_lt ? {created_lt: created_lt.replace("T", " ")} : {}),
              ...(updated_gt ? {updated_gt: updated_gt.replace("T", " ")} : {}),
              ...(updated_lt ? {updated_lt: updated_lt.replace("T", " ")} : {}),
              ...(sort ? {sort: sort} : {})
          }
        })
        .then(async res => {
          console.log(res);
          if(res.data.code === 400) {
            alert("条件設定に問題があります。" + JSON.stringify(res.data.payload))
            return
          } else if(res.data.code === 401) {
            alert("APIKeyが正しく入力されていません。" + JSON.stringify(res.data.message))
            return
          }
          const items = JSON.parse(JSON.stringify(res.data.payload))
          if (items.total > 100000) {
            alert("10万件を超えるデータは表示出来ません。 総件数:" + items.total + "\n日付範囲を調整して下さい。")
            return
          }
          setTotal(items.total)
          setPageNo(items.current_page)
          setLastPageNo(items.last_page)

          items.data.forEach((value: beaconMasterResultType, index: number) => {
            results.push(value)
            results[index].no = items.from;
            items.from++;
          })
          setResult(results)
        })
        .catch(err =>
          alert("エラーが発生しました。" + err)
        )
        } finally {
          setIsFetching(false);
        }
    }

    const createCSV = async (e: React.MouseEvent<HTMLElement, MouseEvent>) => {

      const workbook = new ExcelJS.Workbook();
      workbook.addWorksheet("BeaconMaster");
      const worksheet = workbook.getWorksheet("BeaconMaster");
      const columns: Partial<ExcelJS.Column>[] = [];

      if (isNoCheck) {
        columns.push({ header: "no", key: "no" })
      }
      columns.push({ header: "id", key: "id" })
      columns.push({ header: "name", key: "name" })
      columns.push({ header: "local_name", key: "local_name" })
      columns.push({ header: "uuid", key: "uuid" })
      columns.push({ header: "major", key: "major" })
      columns.push({ header: "minor", key: "minor" })
      columns.push({ header: "action", key: "action" })
      columns.push({ header: "tx_power", key: "tx_power" })
      columns.push({ header: "battery", key: "battery" })
      columns.push({ header: "module_id", key: "module_id" })
      columns.push({ header: "manufacturer", key: "manufacturer" })
      columns.push({ header: "model", key: "model" })
      columns.push({ header: "note", key: "note" })
      columns.push({ header: "x", key: "x" })
      columns.push({ header: "y", key: "y" })
      columns.push({ header: "h", key: "h" })
      columns.push({ header: "latitude", key: "latitude" })
      columns.push({ header: "longitude", key: "longitude" })
      columns.push({ header: "abs_height", key: "abs_height" })
      columns.push({ header: "enabled", key: "enabled" })
      columns.push({ header: "created", key: "created" })
      columns.push({ header: "updated", key: "updated" })

      worksheet.columns = columns;
      setIsLoading(true);
      if (await getAllBeacon(e, 1) == true ) {

        csvResult.forEach((value: beaconMasterResultType) => {
          worksheet.addRow(value);
        });

        csvResult.length = 0;

        console.log("Row Count:" + worksheet.rowCount)
        setIsLoading(false);

        try {
          const uint8Array = await workbook.csv.writeBuffer();
          const blob = new Blob([uint8Array], { type: 'application/octet-binary' });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          setTimeout(()=> {
            a.href = url;
            a.download = "beaconMaster_" + getNowDate() +  ".csv";
            a.click();
            a.remove();
          },1000)

        } catch (error) {
          console.error(error);
        }
      } else {
        setIsLoading(false);
      }
    }

    const getAllBeacon = async(e: any, pageNo: number) => {
      let ret = true;
      e.preventDefault();
      checkLocoEnv();
      await axios.get(apiUrl,
      {
        headers: {
            "Authorization": apiKey,
            "Content-Type": "application/json"
        },
        params: {
            ...(id ? {id: id} : {}),
            ...(pageNo ? {page: pageNo} : {}),
            ...({per_page: 1000}),
            ...(name ? {name: name} : {}),
            ...(local_name ? {local_name: local_name} : {}),
            ...(uuid ? {uuid: uuid} : {}),
            ...(major ? {major: major} : {}),
            ...(minor ? {minor: minor} : {}),
            ...(action_id ? {action_id: action_id} : {}),
            ...(tx_power ? {tx_power: tx_power} : {}),
            ...(battery_gt ? {battery_gt: battery_gt} : {}),
            ...(battery_lt ? {battery_lt: battery_lt} : {}),
            ...(module_id ? {module_id: module_id} : {}),
            ...(manufacturer ? {manufacturer: manufacturer} : {}),
            ...(model ? {model: model} : {}),
            ...(note ? {note: note} : {}),
            ...(x ? {x: x} : {}),
            ...(y ? {y: y} : {}),
            ...(h ? {h: h} : {}),
            ...(enabled ? {enabled: enabled} : {}),
            ...(created_gt ? {created_gt: created_gt.replace("T", " ")} : {}),
            ...(created_lt ? {created_lt: created_lt.replace("T", " ")} : {}),
            ...(updated_gt ? {updated_gt: updated_gt.replace("T", " ")} : {}),
            ...(updated_lt ? {updated_lt: updated_lt.replace("T", " ")} : {}),
            ...(sort ? {sort: sort} : {})
        }
      })
      .then(async res => {
        console.log(res);
        if(res.data.code === 400) {
          alert("条件設定に問題があります。" + JSON.stringify(res.data.payload))
          return ret = false
        } else if(res.data.code === 401) {
          alert("APIKeyが正しく入力されていません。" + JSON.stringify(res.data.message))
          return ret = false
        }
        const items = JSON.parse(JSON.stringify(res.data.payload))
        if (items.total > 100000) {
          alert("10万件を超えるデータは出力出来ません。 総件数:" + items.total + "\n日付範囲を調整して下さい。")
          return ret = false
        }
        let csvArrayCount = csvResult.length;

        items.data.forEach((value: beaconMasterResultType, index: number) => {
          csvResult.push(value);
          csvResult[index + csvArrayCount].no = items.from;
          items.from++;
        })
        setCSVResult(csvResult);
        if (items.current_page != items.last_page) {
          await getAllBeacon(e, items.current_page + 1);
        } else {
          console.log("getall: " + csvResult.length);
        }
      })
      .catch(err =>
        alert("エラーが発生しました。" + err)
      )
      return ret
  }

  const changeCreatedGt = (value: string) => {
    if (value.length >= 1 && value.length < 17) { value = value + ":00"; }
    setCreated_gt(value);
  }
  const changeCreatedLt = (value: string) => {
    if (value.length >= 1 && value.length < 17) { value = value + ":00"; }
    setCreated_lt(value);
  }
  const changeUpdateGt = (value: string) => {
    if (value.length >= 1 && value.length < 17) { value = value + ":00"; }
    setUpdated_gt(value);
  }
  const changeUpdateLt = (value: string) => {
    if (value.length >= 1 && value.length < 17) { value = value + ":00"; }
    setUpdated_lt(value);
  }

  const getNowDate = () => {
    let dt = new Date();
    let y = dt.getFullYear();
    let m = ("00" + (dt.getMonth()+1)).slice(-2);
    let d = ("00" + (dt.getDate())).slice(-2);
    return y + m + d;
  }

  type beaconParamsType = {
    id?: string, perpage?: string, page?: number, name?: string, local_name?: string, uuid?: string,
    major?: string, minor?: string, action_id?: string, tx_power?: string, battery_gt?: string, battery_lt?: string,
    module_id?: string, manufacturer?: string, model?: string, note?: string, x?: string, y?: string, h?: string,
    latitude?: string, longitude?: string, abs_height?: string, enabled?: string,
    created_gt?: string, created_lt?: string, updated_gt?: string, updated_lt?: string, sort?: string
  }

  const saveParams = () => {
    let params: beaconParamsType = {};
    params.id = id ? id : "";
    params.perpage = per_page ? per_page : "";
    params.name = name ? name : "";
    params.local_name = local_name ? local_name : "";
    params.uuid = uuid ? uuid : "";
    params.major = major ? major : "";
    params.minor = minor ? minor : "";
    params.action_id = action_id ? action_id : "";
    params.tx_power = tx_power ? tx_power : "";
    params.battery_gt = battery_gt ? battery_gt : "";
    params.battery_lt = battery_lt ? battery_lt : "";
    params.module_id = module_id ? module_id : "";
    params.manufacturer = manufacturer ? manufacturer : "";
    params.model = model ? model : "";
    params.note = note ? note : "";
    params.x = x ? x : "";
    params.y = y ? y : "";
    params.h = h ? h : "";
    params.latitude = latitude ? latitude : "";
    params.longitude = longitude ? longitude : "";
    params.abs_height = abs_height ? abs_height : "";
    params.enabled = enabled ? enabled : "";
    params.created_gt = created_gt ? created_gt : "";
    params.created_lt = created_lt ? created_lt : "";
    params.updated_gt = updated_gt ? updated_gt : "";
    params.updated_lt = updated_lt ? updated_lt : "";
    params.sort = sort ? sort : "";

    let json = JSON.stringify(params);
    console.log("params:" + json);
    localStorage.setItem("locoBeaconMasterParams", json)
  }

  const saveApikey = () => {
    localStorage.setItem("locoApikey", apiKey ? apiKey : "" );
  }

  const loadParams = () => {
    const paramsJson = localStorage.getItem("locoBeaconMasterParams")
    if (paramsJson != null) {
      const params:beaconParamsType = JSON.parse(paramsJson as string)
      setId(params.id ? params.id : "");
      setPer_Page(params.perpage ? params.perpage : "");
      setName(params.name ? params.name : "");
      setLocal_name(params.local_name ? params.local_name : "");
      setUuid(params.uuid ? params.uuid : "");
      setMajor(params.major ? params.major : "");
      setMinor(params.minor ? params.minor : "");
      setAction_id(params.action_id ? params.action_id : "");
      setTx_power(params.tx_power ? params.tx_power : "");
      setBattery_gt(params.battery_gt ? params.battery_gt : "");
      setBattery_lt(params.battery_lt ? params.battery_lt : "");
      setModule_id(params.module_id ? params.module_id : "");
      setManufacturer(params.manufacturer ? params.manufacturer : "");
      setModel(params.model ? params.model : "");
      setNote(params.note ? params.note : "");
      setX(params.x ? params.x : "");
      setY(params.y ? params.y : "");
      setH(params.h ? params.h : "");
      setLatitude(params.latitude ? params.latitude : "");
      setLongitude(params.longitude ? params.longitude : "");
      setAbs_height(params.abs_height ? params.abs_height : "");
      setEnabled(params.enabled ? params.enabled : "");
      setCreated_gt(params.created_gt ? params.created_gt : "");
      setCreated_lt(params.created_lt ? params.created_lt : "");
      setUpdated_gt(params.updated_gt ? params.updated_gt : "");
      setUpdated_lt(params.updated_lt ? params.updated_lt : "");
      setSort(params.sort ? params.sort : "");
    }
  }

  const loadApikey = () => {
    const locoApikey = localStorage.getItem("locoApikey")
    if (locoApikey != null) { setApikey(locoApikey ? locoApikey : ""); }
  }

  const setSelectApikey = () => {
    const secretJson = localStorage.getItem("locoSecretArray")
    if (secretJson != null) {
      const secret = JSON.parse(secretJson as string)
      const selectApikey = document.getElementById("apikey") as HTMLSelectElement;
      const option1 = document.createElement("option");
      option1.value = "";
      option1.textContent = "APIKeyを選択して下さい";
      selectApikey?.appendChild(option1)
      secret.forEach((element: { apikey: string; name: string | null; }) => {
          const option1 = document.createElement("option");
          option1.value = element.apikey;
          option1.textContent = element.name;
          selectApikey?.appendChild(option1)
      })
    }
  }

  useEffect(() => {
    const secretJson = localStorage.getItem("locoSecretArray")
    if (secretJson != null) { setSelectApikey() }
    loadParams();
    loadApikey();
  },[])

  // close CSV popover on outside click
  useEffect(() => {
    const onClick = (ev: MouseEvent) => {
      if (csvRef.current && !csvRef.current.contains(ev.target as Node)) setCsvOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  // ---- active filter chips (UI only) ----
  type Chip = { key: string; label: string; value: string; clear: () => void };
  const activeChips: Chip[] = [
    apiKey ? { key: "apiKey", label: "ApiKey", value: "設定済み", clear: () => setApikey("") } : null,
    id ? { key: "id", label: "Id", value: id, clear: () => setId("") } : null,
    name ? { key: "name", label: "Name", value: name, clear: () => setName("") } : null,
    local_name ? { key: "ln", label: "LocalName", value: local_name, clear: () => setLocal_name("") } : null,
    uuid ? { key: "uuid", label: "UUID", value: uuid, clear: () => setUuid("") } : null,
    major ? { key: "maj", label: "Major", value: major, clear: () => setMajor("") } : null,
    minor ? { key: "min", label: "Minor", value: minor, clear: () => setMinor("") } : null,
    action_id ? { key: "act", label: "ActionId", value: action_id, clear: () => setAction_id("") } : null,
    tx_power ? { key: "tx", label: "TxPower", value: tx_power, clear: () => setTx_power("") } : null,
    battery_gt ? { key: "bgt", label: "Battery ≥", value: battery_gt + "%", clear: () => setBattery_gt("") } : null,
    battery_lt ? { key: "blt", label: "Battery ≤", value: battery_lt + "%", clear: () => setBattery_lt("") } : null,
    module_id ? { key: "mod", label: "ModuleId", value: module_id, clear: () => setModule_id("") } : null,
    manufacturer ? { key: "mfr", label: "Manufacturer", value: manufacturer, clear: () => setManufacturer("") } : null,
    model ? { key: "model", label: "Model", value: model, clear: () => setModel("") } : null,
    note ? { key: "note", label: "Note", value: note, clear: () => setNote("") } : null,
    enabled ? { key: "en", label: "Enabled", value: enabled === "false" ? "False" : "True", clear: () => setEnabled("") } : null,
    created_gt ? { key: "cgt", label: "Created ≥", value: created_gt, clear: () => setCreated_gt("") } : null,
    created_lt ? { key: "clt", label: "Created ≤", value: created_lt, clear: () => setCreated_lt("") } : null,
    updated_gt ? { key: "ugt", label: "Updated ≥", value: updated_gt, clear: () => setUpdated_gt("") } : null,
    updated_lt ? { key: "ult", label: "Updated ≤", value: updated_lt, clear: () => setUpdated_lt("") } : null,
    sort ? { key: "sort", label: "Sort", value: sort.toUpperCase(), clear: () => setSort("") } : null,
    (per_page) ? { key: "pp", label: "Per_Page", value: per_page, clear: () => setPer_Page("") } : null,
  ].filter(Boolean) as Chip[];

  const resetFilters = () => {
    setId(""); setName(""); setLocal_name(""); setUuid(""); setMajor(""); setMinor("");
    setAction_id(""); setTx_power(""); setBattery_gt(""); setBattery_lt(""); setModule_id("");
    setManufacturer(""); setModel(""); setNote(""); setX(""); setY(""); setH("");
    setLatitude(""); setLongitude(""); setAbs_height(""); setEnabled("");
    setCreated_gt(""); setCreated_lt(""); setUpdated_gt(""); setUpdated_lt("");
    setSort(""); setPer_Page("");
  };

  return (
    <div className="bl-page">
      <Header current_page="BeaconMaster"/>

      <div className="bl-shell">
        {/* ---------- Sidebar: filters ---------- */}
        <aside className={"bl-aside" + (filterOpen ? "" : " collapsed")}>
          <div className="bl-aside-head">
            <span className="bl-aside-title"><Ico name="filter"/> 検索条件</span>
            <button type="button" className="bl-btn ghost sm icon" title={filterOpen ? "閉じる" : "開く"}
              onClick={() => setFilterOpen(o => !o)}>
              <Ico name={filterOpen ? "chevronLeft" : "chevronRight"}/>
            </button>
          </div>

          <form id="bm-filter-form" className="bl-aside-body" autoComplete="on" onSubmit={(e) => getBeacon(e, 0)}>
            <button type="submit" className="bl-btn accent block lg" disabled={isFetching || isLoading}>
              {isFetching ? <><span className="bl-spin-sm" /> 検索中…</> : <><Ico name="search"/> 検索</>}
            </button>

            <div>
              <div className="bl-group-label">接続先</div>
              <div className="bl-fields">
                <div>
                  <label className="bl-field-label">ApiKey</label>
                  <select id="apikey" className="bl-select" value={apiKey} onChange={(e) => setApikey(e.target.value)} />
                </div>
                <div>
                  <label className="bl-field-label">
                    <span>Per_Page</span>
                    <span className="bl-field-hint">既定5 / 最大1000</span>
                  </label>
                  <input className="bl-input" type="text" name="per_page" value={per_page}
                    placeholder="1ページ辺りの最大件数" onChange={(e) => setPer_Page(e.target.value)} />
                </div>
                <div>
                  <label className="bl-field-label">Id</label>
                  <input className="bl-input bl-mono" type="text" value={id} placeholder="Idを入力" onChange={(e) => setId(e.target.value)} />
                </div>
              </div>
            </div>

            <div>
              <div className="bl-group-label">基本情報</div>
              <div className="bl-fields">
                <div><label className="bl-field-label">Name</label><input className="bl-input" value={name} placeholder="Nameを入力" onChange={(e) => setName(e.target.value)} /></div>
                <div><label className="bl-field-label">LocalName</label><input className="bl-input" value={local_name} placeholder="LocalNameを入力" onChange={(e) => setLocal_name(e.target.value)} /></div>
                <div><label className="bl-field-label">UUID</label><input className="bl-input bl-mono" value={uuid} placeholder="UUIDを入力" onChange={(e) => setUuid(e.target.value)} /></div>
              </div>
            </div>

            <div>
              <div className="bl-group-label">Major / Minor / Action</div>
              <div className="bl-grid-2">
                <div><label className="bl-field-label">Major</label><input className="bl-input" value={major} placeholder="Major" onChange={(e) => setMajor(e.target.value)} /></div>
                <div><label className="bl-field-label">Minor</label><input className="bl-input" value={minor} placeholder="Minor" onChange={(e) => setMinor(e.target.value)} /></div>
              </div>
              <div className="bl-fields" style={{ marginTop: 10 }}>
                <div><label className="bl-field-label">ActionId</label><input className="bl-input bl-mono" value={action_id} placeholder="ActionIdを入力" onChange={(e) => setAction_id(e.target.value)} /></div>
              </div>
            </div>

            <div>
              <div className="bl-group-label">デバイス</div>
              <div className="bl-fields">
                <div><label className="bl-field-label">TxPower</label><input className="bl-input" value={tx_power} placeholder="TxPower" onChange={(e) => setTx_power(e.target.value)} /></div>
                <div className="bl-grid-2">
                  <div><label className="bl-field-label">Battery ≥</label><input className="bl-input" value={battery_gt} placeholder="0" onChange={(e) => setBattery_gt(e.target.value)} /></div>
                  <div><label className="bl-field-label">Battery ≤</label><input className="bl-input" value={battery_lt} placeholder="100" onChange={(e) => setBattery_lt(e.target.value)} /></div>
                </div>
                <div><label className="bl-field-label">ModuleId</label><input className="bl-input bl-mono" value={module_id} placeholder="ModuleIdを入力" onChange={(e) => setModule_id(e.target.value)} /></div>
                <div>
                  <label className="bl-field-label">Manufacturer</label>
                  <select className="bl-select" value={manufacturer} onChange={e => setManufacturer(e.target.value)}>
                    <option value="">Manufacturerを選択</option>
                    <option value="Kontakt.io">Kontakt.io</option>
                    <option value="Novars">Novars</option>
                    <option value="Other">Other</option>
                  </select>
                </div>
                <div><label className="bl-field-label">Note</label><input className="bl-input" value={note} placeholder="Noteを入力" onChange={(e) => setNote(e.target.value)} /></div>
              </div>
            </div>

            <div>
              <div className="bl-group-label">状態</div>
              <select className="bl-select" value={enabled} onChange={e => setEnabled(e.target.value)}>
                <option value="">Enabled を指定</option>
                <option value="true">True</option>
                <option value="false">False</option>
              </select>
            </div>

            <div>
              <div className="bl-group-label">Created（作成時刻）</div>
              <div className="bl-fields">
                <div><label className="bl-field-label">以降 (gt)</label><input className="bl-input" type="datetime-local" step="1" value={created_gt} onChange={(e) => changeCreatedGt(e.target.value)} /></div>
                <div><label className="bl-field-label">以前 (lt)</label><input className="bl-input" type="datetime-local" step="1" value={created_lt} onChange={(e) => changeCreatedLt(e.target.value)} /></div>
              </div>
            </div>

            <div>
              <div className="bl-group-label">Updated（更新時刻）</div>
              <div className="bl-fields">
                <div><label className="bl-field-label">以降 (gt)</label><input className="bl-input" type="datetime-local" step="1" value={updated_gt} onChange={(e) => changeUpdateGt(e.target.value)} /></div>
                <div><label className="bl-field-label">以前 (lt)</label><input className="bl-input" type="datetime-local" step="1" value={updated_lt} onChange={(e) => changeUpdateLt(e.target.value)} /></div>
              </div>
            </div>

            <div>
              <div className="bl-group-label">並び順</div>
              <select className="bl-select" value={sort} onChange={e => setSort(e.target.value)}>
                <option value="">ASC / DESC を指定</option>
                <option value="asc">ASC（古い順）</option>
                <option value="desc">DESC（新着順）</option>
              </select>
            </div>

            <div className="bl-aside-actions">
              <button type="submit" className="bl-btn accent block lg" disabled={isFetching || isLoading}>
                {isFetching ? <><span className="bl-spin-sm" /> 検索中…</> : <><Ico name="search"/> 検索</>}
              </button>
              <button type="button" className="bl-btn block" onClick={resetFilters}>Reset</button>
            </div>
          </form>
        </aside>

        {/* ---------- Main ---------- */}
        <main className="bl-main">
          <div className="bl-section-head">
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              {!filterOpen && (
                <button type="button" className="bl-btn ghost sm icon" title="検索条件を開く" onClick={() => setFilterOpen(true)}>
                  <Ico name="filter"/>
                </button>
              )}
              <h2>BeaconMaster</h2>
              {total >= 0 && <span className="bl-badge">{total.toLocaleString()} records</span>}
            </div>

            <div className="bl-toolbar">
              <div className="bl-pop-wrap" ref={csvRef}>
                <div className="bl-split">
                  <button type="button" className="bl-btn secondary" onClick={(e) => createCSV(e)} disabled={isFetching || isLoading}>
                    {isLoading
                      ? <><span className="bl-spin-sm" style={{ borderColor: "rgba(0,0,0,.15)", borderTopColor: "var(--bl-accent)" }} /> 出力中…</>
                      : <><Ico name="download"/> CSV出力</>}
                  </button>
                  <button type="button" className="bl-btn secondary" title="CSV出力オプション" onClick={() => setCsvOpen(o => !o)} disabled={isFetching || isLoading}>
                    <Ico name="chevronDown"/>
                  </button>
                </div>
                {csvOpen && (
                  <div className="bl-pop" style={{ width: 220 }}>
                    <div className="bl-pop-title">CSV出力に含める項目</div>
                    <label className="bl-pop-item">
                      <input type="checkbox" checked={isNoCheck} onChange={() => setNoCheck(p => !p)} /> no
                    </label>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Active filters strip */}
          <div className="bl-chips">
            <span className="bl-chips-label">条件</span>
            {activeChips.length === 0 && <span className="bl-chips-empty">条件は未設定です</span>}
            {activeChips.map(c => (
              <span key={c.key} className="bl-chip">
                <span className="k">{c.label}</span>
                <span className="v bl-mono">{c.value}</span>
                <button type="button" className="x" title="削除" onClick={c.clear}><Ico name="close" size={10}/></button>
              </span>
            ))}
          </div>

          {/* Results */}
          <div className="bl-results-region">
            {(total > 0 && result.length > 0) ? (
              <>
                <Result result={result} />
                <div className="bl-footer">
                  <PageSelect pageNo={pageNo} lastPageNo={lastPageNo} getLog={getBeacon} />
                </div>
              </>
            ) : (
              <div className="bl-empty">
                <Ico name="database" size={28} />
                <span className="big">{total === 0 ? "該当するデータがありません" : "BeaconMasterを検索"}</span>
                <span>{total === 0 ? "条件を変更して再検索してください" : "左の条件を指定して「検索」を押してください"}</span>
              </div>
            )}

            {(isFetching || isLoading) && (
              <div className="bl-overlay">
                <span className="bl-spin-lg" />
                <span>{isLoading ? "CSV出力中… しばらくお待ちください" : "読み込み中…"}</span>
              </div>
            )}
          </div>
        </main>
      </div>
    </div>
  )
}

/* inline icon set — no extra deps */
const Ico = ({ name, size = 14 }: { name: string; size?: number }) => {
  const paths: Record<string, JSX.Element> = {
    filter: <path d="M3 5h18l-7 9v6l-4-2v-4L3 5Z" />,
    search: <><circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" /></>,
    download: <><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><path d="m7 10 5 5 5-5" /><path d="M12 15V3" /></>,
    close: <><path d="M18 6 6 18" /><path d="m6 6 12 12" /></>,
    chevronLeft: <path d="m15 18-6-6 6-6" />,
    chevronRight: <path d="m9 18 6-6-6-6" />,
    chevronDown: <path d="m6 9 6 6 6-6" />,
    database: <><ellipse cx="12" cy="5" rx="9" ry="3" /><path d="M3 5v14a9 3 0 0 0 18 0V5" /><path d="M3 12a9 3 0 0 0 18 0" /></>,
  };
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
      {paths[name]}
    </svg>
  );
};

export default BeaconMaster